import { render, staticRenderFns } from "./effect-analysis-x.vue?vue&type=template&id=201e2d6c&scoped=true"
import script from "./effect-analysis-x.vue?vue&type=script&lang=js"
export * from "./effect-analysis-x.vue?vue&type=script&lang=js"
import style0 from "./effect-analysis-x.vue?vue&type=style&index=0&id=201e2d6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201e2d6c",
  null
  
)

export default component.exports